module.exports = __webpack_public_path__ + "web/img/verify4.93b1d14d.jpg";